const CustomPalette = {
  primary: {
    light: '#b8dbff',
    main: '#0176D3',
    dark: '#2e6499',
  },
  secondary: {
    main: '#E0C2FF',
    light: '#f0e1ff',
    dark: '#9d88b3',
  },
};

export default CustomPalette;
